// Payments service - API client for payment operations
import type { Payment, PaymentMethod } from '@/types/payments';
import { apiFetch } from './operator-api/base-client';

export async function getPayments(filters: {
  businessId?: string;
  status?: string;
  method?: string;
  page?: number;
  pageSize?: number;
}): Promise<Payment[]> {
  if (!filters.businessId) return [];

  const params = new URLSearchParams({ businessId: filters.businessId });
  if (filters.status && filters.status !== 'ALL') params.set('status', filters.status);
  if (filters.method && filters.method !== 'ALL') params.set('method', filters.method);
  if (filters.page) params.set('page', String(filters.page));
  if (filters.pageSize) params.set('pageSize', String(filters.pageSize));

  const res = await apiFetch(`/api/operator/payments?${params.toString()}`);
  if (!res.ok) throw new Error(`Failed to fetch payments: ${res.status}`);

  const json = await res.json();
  if (!json.success) throw new Error(json.error || 'Failed to fetch payments');

  return (json.data || []).map((p: any) => ({
    id: p.id,
    businessId: p.booking?.business?.id || '',
    transactionId: p.transactionId || p.externalId || p.id,
    customerId: p.booking?.customer?.id,
    customerName: p.booking?.customer?.name || 'Customer',
    customerPhone: p.booking?.customer?.phone,
    bookingId: p.bookingId,
    amount: p.amount || (p.amountCents ? p.amountCents / 100 : 0),
    currency: 'BRL',
    status: p.status,
    method: (p.method || 'PIX') as PaymentMethod,
    type: 'SERVICE' as const,
    createdAt: new Date(p.createdAt),
    completedAt: p.refundedAt ? new Date(p.refundedAt) : undefined,
  }));
}
